import { createPath } from "@odata/BindingContext";
import { PrDeductionEntity, PrDeductionOtherPaymentEntity } from "@odata/GeneratedEntityTypes";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import OtherPaymentsFormView from "@pages/payroll/deduction/OtherPaymentsFormView";
import { getPayrollCurrencyFieldDef } from "@pages/payroll/payroll.utils";

import { BasicInputSizes, Sort } from "../../../enums";
import { IFormDef } from "../../../views/formView/Form";

export const getDefinitions: IGetDefinition = (): IDefinition => {
    const form: IFormDef = {
        id: `OtherPaymentsSpecialForm`,
        summary: [],
        translationFiles: getDefinitions.translationFiles,
        formControl: OtherPaymentsFormView,
        fieldDefinition: {
            [createPath(PrDeductionEntity.OtherPayments, PrDeductionOtherPaymentEntity.Amount)]: {
                ...getPayrollCurrencyFieldDef()
            },
            [createPath(PrDeductionEntity.OtherPayments, PrDeductionOtherPaymentEntity.Date)]: {},
            [createPath(PrDeductionEntity.OtherPayments, PrDeductionOtherPaymentEntity.Description)]: {
                width: BasicInputSizes.L
            },
        },
        groups: [{
            id: "main",
            lineItems: {
                collection: PrDeductionEntity.OtherPayments,
                order: "Id",
                orderDirection: Sort.Asc,
                canReorder: false,
                showLineNumbers: false,
                isItemCloneable: false,
                // last item should be removable, so user can remove all the items if needed
                // (when they are already saved -> cancel won't work in that case)
                isTheOnlyItemRemovable: true,
                columns: [
                    { id: PrDeductionOtherPaymentEntity.Date },
                    { id: PrDeductionOtherPaymentEntity.Amount },
                    { id: PrDeductionOtherPaymentEntity.Description }
                ],
            }
        }]
    };

    return {
        form
    };
};

getDefinitions.translationFiles = ["Deduction", "Common"];